import { Message } from "@/store/chats/types";
import { format } from "date-fns";

export const getMessageDate = (message: Message): string => {
  return format(new Date(message.sentAt), "dd.MM.yyyy, HH:mm");
};
